'use client'

import { useMemo } from 'react'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import {
  InputDropdownSelectType,
  SelectableInputDropdown,
} from '@marketplace-web/common-components/selectable-input-dropdown-ui'
import { BundleDiscountModel } from '@marketplace-web/bundles/items-bundle-data'
import { useBreakpoint } from '@marketplace-web/breakpoints/breakpoints-feature'

type Props = {
  isDisabled: boolean
  discountFractions: Array<string>
  selectedDiscounts: Array<BundleDiscountModel>
  onDiscountSelection: (discounts: BundleDiscountModel) => void
}

const BundleDiscountsSelectionList = ({
  isDisabled,
  discountFractions,
  selectedDiscounts,
  onDiscountSelection,
}: Props) => {
  const translate = useTranslate('settings.bundle_discounts')
  const selectableInputDropdownTranslate = useTranslate()
  const breakpoints = useBreakpoint()

  const fractionDropDownValues = useMemo<Array<InputDropdownSelectType>>(() => {
    return discountFractions.map(fraction => {
      const fractionNumeric = Number(fraction)

      return {
        id: fraction,
        title: fractionNumeric === 0 ? translate('no_discount') : `${fractionNumeric * 100}%`,
      }
    })
  }, [translate, discountFractions])

  function getSelectedDropDownValue(discount: BundleDiscountModel) {
    return fractionDropDownValues.find(fraction => fraction.id === discount.fraction)
  }

  function handleDiscountSelection(discount: BundleDiscountModel) {
    return (value?: InputDropdownSelectType | null) => {
      if (!value) return
      onDiscountSelection({
        ...discount,
        fraction: String(value.id),
      })
    }
  }

  return (
    <>
      {selectedDiscounts.map((discount, index) => (
        <SelectableInputDropdown
          isPhone={!!breakpoints.phones}
          disabled={isDisabled}
          key={discount.minimalItemCount}
          name={`bundle-discount-selector-${index}`}
          inputTitle={translate(
            'items',
            { count: discount.minimalItemCount },
            { count: discount.minimalItemCount },
          )}
          data={fractionDropDownValues}
          selectedValue={getSelectedDropDownValue(discount)}
          onSave={handleDiscountSelection(discount)}
          textSave={selectableInputDropdownTranslate('actions.save')}
        />
      ))}
    </>
  )
}

export default BundleDiscountsSelectionList
